// Market-specific profession noun, mirroring the WP directory's
// expy_dir_provider_noun(): US says "physical therapist" (bare "therapist"
// reads as mental-health care there), the UK says "physiotherapist".
//
// The ZIP/postcode step now runs BEFORE the matching block (intent, payment,
// insurance, gender), so that copy — and everything at/after the Result screen —
// resolves the country through this helper (flow.ts wraps it as ptNoun). Only the
// purely-clinical questions before ZIP render without a country; they never name
// the profession, so they need no noun.
export function providerNoun(country?: string | null, plural = false): string {
  const noun = country === 'GB' ? 'physiotherapist' : 'physical therapist';
  return plural ? `${noun}s` : noun;
}
